module.exports = "pegasus_template/assets/email1-company-logo2.png";